import { pushToDataLayer } from '@arnold/common';
import { createContext, useCallback, useContext } from 'react';
import auth from '../lib/auth';

type ReportGTMDimensions = {
  organization_id: string;
  organization_name: string;
  report_name: string;
  report_type: 'One-time' | 'Onboarding';
};

export const buildReportGTMDimensions = (params: {
  organizationId: string;
  organizationName: string;
  reportName: string;
  reportType: ReportGTMDimensions['report_type'];
}): ReportGTMDimensions => ({
  organization_id: params.organizationId,
  organization_name: params.organizationName,
  report_name: params.reportName,
  report_type: params.reportType,
});

export const ReportGTMContext = createContext<ReportGTMDimensions | null>(null);

const useReportGTMDimensions = () => useContext(ReportGTMContext);

export const usePushReportEvent = () => {
  const gtmDimensions = useReportGTMDimensions();

  return useCallback(
    (event: string, actionName: string, extraHit?: Record<string, unknown>) => {
      const userId = auth.getUserId();
      pushToDataLayer({
        event,
        hit: {
          event_type: 'generic_event',
          action_name: actionName,
          ...(userId && { user_id: userId }),
          ...(gtmDimensions && gtmDimensions),
          ...extraHit,
        },
        _clear: true,
      });
    },
    [gtmDimensions],
  );
};
